import styles from './style.styl'
import ComponentFromProp from '../component-from-prop'
import { cc, range, withClass } from '../../utils'
import { Alt, Regular, RegularBig, Small } from '../text'
import { FbIntroIcon, IgIntroIcon, LiIntroIcon, PcIntroIcon, TwIntroIcon, YtIntroIcon } from '../social'
import { Ribbons } from '../ribbons'

const Cell = withClass(
  cc(styles.gridCell, 'centered')
)(ComponentFromProp)

const Title = () => (
  <Cell className={styles.title}>
    <a href={'https://futurelondonacademy.co.uk/'} target={'_blank'}>
      <Small>
        F<Alt>u</Alt>t<Alt>u</Alt>re<br />
        London<br />
        <Alt>A</Alt>c<Alt>a</Alt>demy
      </Small>
    </a>
  </Cell>
)
const Description = () => (
  <Cell className={styles.description}>
    <Regular>
      Imagine that a year from now you could finally get that Chief Creative Officer promotion, scale your business, and lead a larger team. It all starts here.
    </Regular>
  </Cell>
)

const Slogan = () => (
  <Cell className={styles.slogan}>
    <RegularBig>
      Finally, a Business Programme&nbsp;for <br />Design Leaders
    </RegularBig>
  </Cell>
)

const scrollToSection = (id) => {
  const section = document.getElementById(id)
  const { top } = section.getBoundingClientRect()
  window.scrollTo({ top: top + window.scrollY, behavior: 'smooth' })
}

const Menu = () => (
  <Cell className={styles.menuCell}>
    <Small as={'span'} className={styles.menuItem} onClick={() => scrollToSection('programme')}>
      Programme
    </Small>
    <Small as={'span'} className={styles.menuItem} onClick={() => scrollToSection('reviews')}>
      Rev<span className='alt'>i</span>ews
    </Small>
    <Small as={'span'} className={styles.menuItem} onClick={() => scrollToSection('date_price')}>
      Price
    </Small>
    <Small as={'span'} className={styles.menuItem} onClick={() => scrollToSection('apply')}>
      Apply now
    </Small>
  </Cell>
)

const Date = () => (
  <Cell className={styles.date}>
    {/* <Small as='span'> */}
    {/*   JULY 2023 */}
    {/* </Small> */}
  </Cell>
)

const createCells = (cols, rows, isMobile) => range(cols).map(col => range(rows).map(row => (
  <Cell
    className={isMobile ? styles.gridCellM : styles.gridCellD}
    style={{
      gridArea: `${row + 1} / ${col + 1} / span 1 / span 1`
    }}
  />
)))

const RotatingSquare = () => (
  <Cell className={styles.rotatingSquare} />
)

const Circle = withClass(styles.circle)('div')

const DoubleCircle = () => (
  <Cell className={styles.doubleCircle}>
    <div className={styles.circleBox}>
      <Circle />
      <Circle />
    </div>
  </Cell>
)

const FlippingCircle = () => (
  <Cell className={styles.flippingCircle}>
    <div className={styles.flippingCircleContent} />
  </Cell>
)

const BlackCircle = (props) => (
  <Cell {...props}>
    <div className={styles.blackCircleContent} />
  </Cell>
)

const EmptyRect = () => (
  <Cell className={styles.emptyRect} />
)

const FullRect = () => (
  <Cell className={styles.fullRect} />
)

const HalfCircle = (props) => (
  <Cell {...props}>
    <div className={styles.halfCircleContent} />
  </Cell>
)

const SocialCell = () => (
  <Cell className={styles.socialCell}>
    <div className={styles.socialCellRow}>
      <FbIntroIcon />
      <TwIntroIcon />
      <IgIntroIcon />
    </div>
    <div className={styles.socialCellRow}>
      <YtIntroIcon />
      <LiIntroIcon />
      <PcIntroIcon />
    </div>
  </Cell>
)

const cells = createCells(8, 4)
const cellsM = createCells(3, 5, true)

const Grid = () => (
  <div className={styles.grid}>
    {cells}
    {cellsM}
    <Title />
    <Description />
    <Slogan />
    <EmptyRect />
    <FullRect />
    <Date />
    <RotatingSquare />
    <DoubleCircle />
    <FlippingCircle />
    <BlackCircle className={styles.blackCircle1} />
    <BlackCircle className={styles.blackCircle2} />
    <Menu />
    <HalfCircle className={styles.halfCircle1} />
    <HalfCircle className={styles.halfCircle2} />
    <SocialCell />
    <Ribbons />
  </div>
)

const Intro = () => (
  <div className={styles.intro}>
    <Grid />
  </div>
)

export default Intro



// WEBPACK FOOTER //
// ./components/intro/index.js